import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { QuoteModel } from '../components/models/quote.model';
import { Wallet } from '../components/models/wallet.model';
import { createHttpOptions } from '../utils/http-utils';
import { Asset } from '../components/models/asset.model';
import { CreatePaymentReportDto } from '../dtos/create-payment-report.dto';
import { GetTxInfoRequest } from '../components/models/get-tx-info-model';
import { GetTxInfoResult } from '../components/models/get-tx-info-result.model';
import { ResumePayment } from '@app/components/models/resume-payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private http = inject(HttpClient);

  getUserWallets(targetNick: string, selectedAsset: string, paymentRequestShortId: string | undefined = undefined) {
    return this.http.get<Wallet>(
      `${environment.api}Address/deposit-address?assetId=${selectedAsset}&nick=${targetNick}${paymentRequestShortId ? '&paymentRequestShortId=' + paymentRequestShortId : ''}`,
      createHttpOptions('text/plain'),
    );
  }

  getPrice(currency: string, targetCurrency: string) {
    const body = {
      amount: 1,
      fromBlockchainId: currency,
      toBlockchainId: targetCurrency,
    };
    return this.http.post<QuoteModel>(`${environment.api}ConversionRate/get-price`, body, createHttpOptions());
  }

  getQuotes(amount: number, currency: string, targetCurrency: string) {
    const body = {
      amount: amount,
      fromBlockchainId: currency,
      toBlockchainId: targetCurrency,
    };
    return this.http.post(`${environment.api}ConversionRate/get-quote`, body, createHttpOptions());
  }

  txInfo(txInfo: GetTxInfoRequest) {
    const body = txInfo;
    return this.http.post<GetTxInfoResult[]>(`${environment.api}PaymentReport/tx-info`, body, createHttpOptions());
  }

  getTransactions(assetId: string, address: string, dateTime: string) {
    return this.http.get(
      `${environment.api}Blockchain/transactions/${assetId}/${address}?startTime=${dateTime}`,
      createHttpOptions('text/plain'),
    );
  }

  doTransaction(paymentReport: CreatePaymentReportDto) {
    const body = paymentReport;

    return this.http.post(`${environment.api}PaymentReport/create`, body, createHttpOptions());
  }

  sendResumePaymentEmail(resumeEmail: ResumePayment) {
    const body = resumeEmail;
    return this.http.post(`${environment.api}resumePayment/create`, body, createHttpOptions());
  }

  getAllAssets() {
    return this.http.post<Asset[]>(`${environment.api}BlockchainAsset/all`, {}, createHttpOptions('text/plain'));
  }

  getUnusedQuoteById(quoteId: string) {
    return this.http.get<QuoteModel>(
      `${environment.api}ConversionRate/get-unused-quote-by-id?quoteId=${quoteId}`,
      createHttpOptions(),
    );
  }
}
